module.exports = __webpack_public_path__ + "static/media/close.c5fc258d.svg";